import React, { useState, useEffect } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Overview', href: '#overview' },
    { name: 'Technology', href: '#technology' },
    { name: 'Impact', href: '#impact' },
    { name: 'Team', href: '#team' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container nav-content">
        <button className="logo" onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}>
          <img src="/logo.png" alt="Latent Energy" className="logo-img" />
        </button>

        <ul className="nav-links desktop">
          {navItems.map((item, index) => (
            <li key={item.name}>
              <a href={item.href}>{item.name}</a>
            </li>
          ))}
          <li>
            <a
              href="#overview"
              className="btn-contact"
            >
              Learn More
            </a>
          </li>
        </ul>

        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
          <a
            href="#overview"
            className="btn-contact"
            onClick={() => setMobileMenuOpen(false)}
          >
            Learn More
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
